import { render } from "./ModelSelectPage.vue?vue&type=template&id=16a3d95f&scoped=true"
import script from "./ModelSelectPage.vue?vue&type=script&lang=js"
export * from "./ModelSelectPage.vue?vue&type=script&lang=js"

import "./ModelSelectPage.vue?vue&type=style&index=0&id=16a3d95f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a3d95f"]])

export default __exports__